"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1331],{

/***/ 21331:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33616);
var _path, _path2, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgServicioProfesionalizadoAlquilerCircle = function SvgServicioProfesionalizadoAlquilerCircle(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M29.833 21.663c-.17.002-.34.033-.5.092v-2.592a1.5 1.5 0 0 0-1.5-1.5h-7a1.5 1.5 0 0 0-1.5 1.5v2.592c-.16-.059-.33-.09-.5-.092a1.5 1.5 0 0 0-1.5 1.5v4a1.5 1.5 0 0 0 1.5 1.5h2.306l-.78 2.342a.5.5 0 0 0 .948.316l.886-2.658h4.28l.886 2.658a.5.5 0 1 0 .948-.316l-.78-2.342h2.306a1.5 1.5 0 0 0 1.5-1.5v-4a1.5 1.5 0 0 0-1.5-1.5Zm-9.5-2.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v5.013a2.47 2.47 0 0 0-1.5-.513h-5a2.47 2.47 0 0 0-1.5.513v-5.013Zm-2 8v-4a.5.5 0 1 1 1 0v4.5h-.5a.5.5 0 0 1-.5-.5Zm2-1a1.5 1.5 0 0 1 1.5-1.5h5a1.5 1.5 0 0 1 1.5 1.5v1.5h-8v-1.5Zm10 1a.5.5 0 0 1-.5.5h-.5v-4.5a.5.5 0 1 1 1 0v4Z",
    fill: "CurrentColor"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M17.733 30.663h-1.43l.03-12h1.5a.5.5 0 0 0 .485-.62l-1-4a.5.5 0 0 0-.485-.38h-2a.5.5 0 0 0-.485.38l-1 4a.5.5 0 0 0 .485.62h1.5l-.03 12h-1.436a.5.5 0 1 0 0 1h3.866a.5.5 0 1 0 0-1Zm-2.509-16h1.218l.75 3h-2.718l.75-3Z",
    fill: "CurrentColor"
  })), _rect || (_rect = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", {
    x: 0.833,
    y: 1.163,
    width: 42,
    height: 42,
    rx: 21.5,
    stroke: "#765346"
  })));
};
/* harmony default export */ __webpack_exports__["default"] = (SvgServicioProfesionalizadoAlquilerCircle);

/***/ })

}]);